import type { TableSortDirections } from './constants'
import type { BaseTableRow } from './types'

import { tableSortDirections } from './constants'

export function defaultTableSort<TR extends BaseTableRow>(
  rows: TR[],
  sortBy: string,
  sortDirection: TableSortDirections
): TR[] {
  const rowsToSort = [...rows]

  return rowsToSort.sort((a, b) => {
    if (!sortBy) {
      return 0
    }

    const aValue = a[sortBy as keyof TR]
    const bValue = b[sortBy as keyof TR]

    // Handle null/undefined values - sort them to the end
    if (aValue === null || aValue === undefined) {
      return 1
    }
    if (bValue === null || bValue === undefined) {
      return -1
    }

    if (aValue < bValue) {
      return -1 * (sortDirection === tableSortDirections.DESC ? -1 : 1)
    }

    if (aValue > bValue) {
      return 1 * (sortDirection === tableSortDirections.DESC ? -1 : 1)
    }

    return 0
  })
}
